import React from 'react'
import { useIntl } from 'react-intl'
import { IconChartBar } from '@vtex/phosphor-icons'
import { csx } from '@vtex/admin-ui'

import { ContextualActionButton } from '../../../../core/components/ContextualActionButton'

export type OpenGoalsButtonProps = {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
}

export const OpenGoalsButton = ({
  onClick,
  ...props
}: OpenGoalsButtonProps) => {
  const intl = useIntl()

  return (
    <>
      <ContextualActionButton
        color="black"
        className={csx({
          color: 'black',
          ':hover': { color: '$action.main.secondaryHover' },
        })}
        icon={
          <IconChartBar
            color="black"
            className={csx({
              ':hover': { color: '$action.main.secondaryHover' },
            })}
          />
        }
        onClick={onClick}
        data-testid="open-goals-button"
        {...props}
      >
        <span
          className={csx({
            color: '$black',
            ':hover': { color: '$action.main.secondaryHover' },
          })}
        >
          {intl.formatMessage({ id: 'goals' })}
        </span>
      </ContextualActionButton>
    </>
  )
}
